$(() => {
  const homeData = document.getElementById('js-data-home-page');
  const { display } = homeData.dataset;
  const { previousLot } = homeData.dataset;

  $('select.changeSize').change(function changeSize() {
    const e = $(this).val();
    const i = '/';
    window.location.href = `${i}?pageSize=${e}`;
  });
  $('label.display').click(function changeDisplay() {
    const e = '/';
    const i = $(this).attr('id');
    window.location.href = `${e}?display=${i}`;
  });

  if (previousLot !== '') {
    let $anchor = $(`#${previousLot}`);
    const extraOffset = $(window).height() / 2;

    if ($anchor.length) {
      if ($(window).width() < 600) {
        // Mobile view
        $anchor = $(`#m${previousLot}`);
        $anchor.children('.auto-list-mobile').addClass('focused');
        $anchor.css('border-bottom', 'red');
      } else if (display === 'site.lists.list') {
        $anchor.children('div.auto-list').addClass('focused');
      } else {
        $anchor.addClass('focused');
      }

      $('html, body').animate({
        scrollTop: $anchor.offset().top - extraOffset,
      }, 1000);
    }
  }
});
